module.exports = "<div> <register-customer-user-component @register-customer-user-success=successHandler></register-customer-user-component> </div> ";